import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';

@Component({
  selector: 'Teranet-ErrorCode',
  templateUrl: './error-code.component.html',
  styleUrls: ['./error-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorCodeComponent implements OnInit {
  color: string = 'red';
  icon: string = 'exclamation';
  message: string = null;
  title: string = 'Unanthorizied Access';

  constructor(public authService: AuthService, private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state as {
      color: string;
      icon: string;
      message: string;
      title: string;
    };
    if (state) {
      this.color = state.color;
      this.icon = state.icon;
      this.message = state.message;
      this.title = state.title;
    }
  }

  ngOnInit() { }

  goToLogin() {
    this.authService.logout();
    this.router.navigateByUrl('login');
  }
}
